import { render } from "./prompt-actions-dropdown.vue?vue&type=template&id=7a971e34&lang=pug"
import script from "./prompt-actions-dropdown.vue?vue&type=script&lang=js"
export * from "./prompt-actions-dropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__